module.exports = __webpack_public_path__ + "img/404.6ec1be30.png";